// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer-module--container--2dsTv","description":"Footer-module--description--h9Ekv","logo":"Footer-module--logo--3Uan7"};